"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useIssueTypeCode = exports.useAssigneeName = exports.getIssueUrl = void 0;
var _viewPaths = require("../../IssuesTab/navigation/viewPaths");
var _issueTypes = require("../../state/redux/ducks/issueTypes");
var _hooks = require("../../state/redux/hooks");
var _oxygenUtils = require("../../utils/data/oxygenUtils");
var _projectMembersHooks = require("../../utils/hooks/projectMembersHooks");
var _useTranslations = require("../../utils/i18n/useTranslations");
const useAssigneeName = issue => {
  const usersEntitiesMap = (0, _projectMembersHooks.useUsersEntitiesMapByOxygenId)();
  const rolesEntitiesMap = (0, _projectMembersHooks.useRolesEntitiesMapByOxygenId)();
  const companiesEntitiesMap = (0, _projectMembersHooks.useCompaniesEntitiesMapByOxygenId)();
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  return (0, _oxygenUtils.getProjectMemberDisplayName)({
    usersEntitiesMap,
    rolesEntitiesMap,
    companiesEntitiesMap,
    id: issue.assignedTo,
    T
  }) || T.translate("issuesListItem.unassigned");
};
exports.useAssigneeName = useAssigneeName;
const getIssueUrl = _ref => {
  let {
    projectId,
    issueId
  } = _ref;
  return "/".concat((0, _viewPaths.getAppName)(), "/issues/projects/").concat(projectId, "/issues?issueId=").concat(issueId);
};
exports.getIssueUrl = getIssueUrl;
const useIssueTypeCode = issueTypeId => {
  const issueTypeEntitiesMap = (0, _hooks.useSelector)(_issueTypes.getIssueTypeEntitiesMap);
  const issueType = issueTypeId ? issueTypeEntitiesMap[issueTypeId] : undefined;
  return issueType ? issueType.code : undefined;
};
exports.useIssueTypeCode = useIssueTypeCode;
//# sourceMappingURL=utils.js.map